<template>
  <div class="btn-box">
    <el-button class="download-button" round @click.native="openUrl(buyLink)">去购买</el-button>
    <el-button
      class="download-button"
      round
      @click.native="openUrl('https://apps.apple.com/cn/app/id1423132930')"
    >下载「我的物品」 App</el-button>
  </div>
</template>

<script>
export default {
  props: {
    buyLink: String
  },
  methods: {
    openUrl(url) {
      if (url === "action1") {
        window.open(this.buyLink, "_blank");
      } else {
        if (url === "https://myitems.moshouapp.com") {
          this.$message("没有设置购买来源链接");
        } else {
          window.open(url, "_blank");
        }
      }
    }
  }
};
</script>

<style>
.download-view {
  width: 375px;
}
.download-button:hover {
  background-color: #ffca7b;
  border-color: #ffb547;
  color: white;
}
.btn-box {
  width: 359px;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin-left: 8px;
}
.download-button {
  width: 50%;
}
</style>
